import { IDestroyOptions } from "pixi.js";
import { MyWalletTab } from "../MyWalletTab";
import { MyWalletResourcePackage } from "../../../resources/MyWalletResourcePackage";
import { WalletTabType } from "../../WalletTabType";
import { Web3Model } from "../../../../../../../web3/models/Web3Model";
import { ILogger } from "../../../../../../logger/ILogger";
import { Web3Config } from "../../../../../../../web3/config/Web3Config";
import { MainTokenFrame } from "./frames/MainTokenFrame";
import { ITokenFrame } from "./frames/ITokenFrame";
import { ICanvasScaler } from "../../../../../../../canvas/ICanvasScaler";
import { FullscreenInputBlocker } from "../../../../../game/components/FullscreenInputBlocker";
import { CommonResourcesPackage } from "../../../../../common/resources/CommonResourcesPackage";
import { ReceiveErc20Frame } from "./frames/ReceiveErc20Frame";
import { SendErc20Frame } from "./frames/SendErc20Frame";
import { IMyWalletController } from "../../../controllers/IMyWalletController";
import { GameInfo } from "../../../../../../../analytics/GameInfo";


export class TokensTab extends MyWalletTab {
    private readonly mainFrame: MainTokenFrame;
    private readonly receiveMonFrame: ReceiveErc20Frame;
    private readonly receiveUsdcFrame: ReceiveErc20Frame;
    private readonly sendMonFrame: SendErc20Frame;
    private readonly sendUsdcFrame: SendErc20Frame;

    private currentFrame: ITokenFrame;

    public constructor(
        commonResources: CommonResourcesPackage,
        myWalletResources: MyWalletResourcePackage,
        web3Model: Web3Model,
        web3Config: Web3Config,
        myWalletController: IMyWalletController,
        private readonly canvasScaler: ICanvasScaler,
        private readonly gameInfo: GameInfo,
        logger: ILogger
    ) {
        super(false, WalletTabType.TOKENS);

        this.currentFrame = this.mainFrame = new MainTokenFrame(
            myWalletResources,
            web3Model,
            web3Config,
            logger
        );
        this.receiveMonFrame = new ReceiveErc20Frame('MON', commonResources, myWalletResources, web3Model);
        this.sendMonFrame = new SendErc20Frame(web3Config.ethL1Chain, web3Config.monCurrencyAddress, 'MON', commonResources, myWalletResources, myWalletController, web3Model, canvasScaler, this.gameInfo);

        this.receiveUsdcFrame = new ReceiveErc20Frame('USDC', commonResources, myWalletResources, web3Model);
        this.sendUsdcFrame = new SendErc20Frame(web3Config.targetChain, web3Config.reservoirDevUsdcCurrency, 'USDC', commonResources, myWalletResources, myWalletController, web3Model, canvasScaler, this.gameInfo);

        this.addChild(this.currentFrame);

        this.mainFrame.onReceiveMonClick.add(this.onReceiveMonClick, this);
        this.mainFrame.onSendMonClick.add(this.onSendMonClick, this);
        this.receiveMonFrame.onBackButtonClick.add(this.onBackButtonClick, this);
        this.sendMonFrame.onBackButtonClick.add(this.onBackButtonClick, this);

        this.mainFrame.onReceiveUsdcClick.add(this.onReceiveUsdcClick, this);
        this.mainFrame.onSendUsdcClick.add(this.onSendUsdcClick, this);
        this.receiveUsdcFrame.onBackButtonClick.add(this.onBackButtonClick, this);
        this.sendUsdcFrame.onBackButtonClick.add(this.onBackButtonClick, this);
    }

    public override async show(): Promise<void> {
        await Promise.all([super.show(), this.currentFrame.show()]);
    }

    public override async hide(): Promise<void> {
        await Promise.all([super.hide(), this.currentFrame.hide()]);
    }

    public updatePointer(): void {
        return;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.mainFrame.onReceiveMonClick.remove(this.onReceiveMonClick, this);
        this.mainFrame.onSendMonClick.remove(this.onSendMonClick, this);
        this.receiveMonFrame.onBackButtonClick.remove(this.onBackButtonClick, this);
        this.sendMonFrame.onBackButtonClick.remove(this.onBackButtonClick, this);

        this.mainFrame.onReceiveUsdcClick.remove(this.onReceiveUsdcClick, this);
        this.mainFrame.onSendUsdcClick.remove(this.onSendUsdcClick, this);
        this.receiveMonFrame.onBackButtonClick.remove(this.onBackButtonClick, this);
        this.sendMonFrame.onBackButtonClick.remove(this.onBackButtonClick, this);


        this.mainFrame.destroy(options);
        this.receiveMonFrame.destroy(options);
        this.sendMonFrame.destroy(options);
        this.receiveUsdcFrame.destroy(options);
        this.sendUsdcFrame.destroy(options);
        super.destroy(options);
    }

    private async onBackButtonClick(): Promise<void> {
        await this.switchFrame(this.mainFrame);
    }

    private async onReceiveMonClick(): Promise<void> {
        await this.switchFrame(this.receiveMonFrame);
    }

    private async onSendMonClick(): Promise<void> {
        await this.switchFrame(this.sendMonFrame);
    }

    private async onReceiveUsdcClick(): Promise<void> {
        await this.switchFrame(this.receiveUsdcFrame);
    }

    private async onSendUsdcClick(): Promise<void> {
        await this.switchFrame(this.sendUsdcFrame);
    }

    private async switchFrame(frame: ITokenFrame): Promise<void> {
        const inputBlocker = new FullscreenInputBlocker(this.canvasScaler);
        this.addChild(inputBlocker);
        await this.currentFrame.hide();
        this.removeChild(this.currentFrame);
        this.currentFrame = frame;
        this.addChild(this.currentFrame);
        await this.currentFrame.show();
        this.removeChild(inputBlocker);
    }
}